import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environment/environment';
import { tap } from 'rxjs/operators';
import { ITenantInformationDTO } from '@app/core/models/tenantInformationDTO.model';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  public _tenants: ITenantInformationDTO[] = null;
  public _tenant: ITenantInformationDTO = null;

  constructor(public http: HttpClient) { }

  getTenants(): Observable<Array<ITenantInformationDTO>> {
    if (this._tenants) {
      return of(this._tenants);
    } else {
      const endpointUrl = `${environment.apiUrl}master/tenant`;
      return this.http.get<ITenantInformationDTO[]>(endpointUrl)
        .pipe(tap(t => {
          this._tenants = t;
        }));
    }
  }
}
